import React, { useState } from "react";

import Sidebar from "./Sidebar/Sidebar";
import Service from "./Pages/Service/Service";
import Ride from "./Pages/Rides/Ride";
import Income from "./Pages/Income/Income";
import Offer from "./Pages/Offers/Offer";
import Staff from "./Pages/Staff/Staff";
import Location from "./Pages/Locations/Location";
import City from "./Pages/City/City";
import Driver from "./Pages/Driver/Driver";
import DriversTable from "./Pages/DriversTable";
import AdminFareEditor from "./fare/AdminFareEditor";
import StatsDashboard from "./Pages/Income/StatsDashboard";
import AdminRides from "./Pages/Rides/ridesList";
import CityVehicleFareManager from "./VehicleFareList";



function Sidebarapp() {
  const [activeTab, setActiveTab] = useState("city");
  const [driver, setDriver] = useState(null);

  const renderContent = () => {
    switch (activeTab) {
       case "fares":
        return <AdminFareEditor />;
      // case "city":
      //   return <City />;
      // case "location":
      //   return <Location />;
      case "services":
        return <CityVehicleFareManager />;
      case "staff":
        return <Staff />;
      case "offers":
        return <Offer />;
      case "income":
        return <StatsDashboard />;
      case "rides":
        return <AdminRides />;
        case "driver":
          return <DriversTable  onOpenDocs={(d) => setDriver(d)}/>;
      default:
        return <AdminFareEditor />;

    }
  };

  return (
    <div className="flex h-screen">
      <Sidebar setActiveTab={setActiveTab} activeTab={activeTab} />
      <div className="flex-1 bg-white p-6 overflow-auto">{renderContent()}</div>
     
    </div>
  );
}

export default Sidebarapp;
